const productsAddBtn = document.querySelectorAll('.related-products__formButton');
const checkoutButton = document.querySelector('.related-products__checkout');
const selectVariant = document.querySelectorAll('.selectVariantId');

// change price
selectVariant.forEach((el) => {
    el.addEventListener('change', (event) => {
        let variantId = el.value;


        pricePackInBlock = el.parentNode.querySelectorAll('.related-products__product-price');
        pricePackInBlock.forEach((price) => {
            price.classList.add("hidden");
            if (price.getAttribute("value") == variantId) {
                price.classList.remove("hidden");
            }
        });


        imagePackInBlock = el.parentNode.querySelectorAll('.related-products__product-image img');
        imagePackInBlock.forEach((img) => {
            img.classList.add("hidden");
            if (img.getAttribute("value") == variantId) {
                img.classList.remove("hidden");
            }
        });
    });
});

productsAddBtn.forEach((el) => {
    el.addEventListener('click', (event) => {
        event.preventDefault();
        const variantIDdrawer = el.parentNode.parentNode.querySelector('.selectVariantId').value;
        addToCart(variantIDdrawer, el);
    });
});

async function addToCart(variantIDdrawer, button) {
    const formData = {
        items: [
            {
                id: variantIDdrawer,
                quantity: 1,
            },
        ],
    };

    const addToCartPromise = await fetch(
        window.Shopify.routes.root + 'cart/add.js',
        {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(formData),
        }
    );

    if (!addToCartPromise.ok) {
        console.error('Error:', error);
    }

    button.textContent = 'THANKS!..';

    checkoutButton.click();
}